import { FC, PropsWithChildren } from "react";
import { BrowserRouter } from "react-router-dom";
import { RouteStateProvider } from './RouteStateContext';

const RoutingContext: FC<PropsWithChildren> = ({ children }) => {
    return (
        <BrowserRouter>
            <RouteStateProvider>
                {children}
            </RouteStateProvider>
        </BrowserRouter>
    );
};

export default RoutingContext;